import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_Arbaz/cwd-website/src/components/About/AboutPageContent.tsx");
